var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3eb1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bacc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368ba7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "j",
    x1: 458,
    y1: -51.7,
    x2: 442.5,
    y2: -202.2,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ca2b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aedce8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 396.4,
    y1: -224.9,
    x2: 378.8,
    y2: -368.2,
    gradientTransform: "translate(-3.6 -1.8)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 450.1,
    y1: -143.3,
    x2: 433.4,
    y2: -242.5,
    gradientTransform: "translate(-3.6 -1.8)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 489.5,
    y1: -113.5,
    x2: 442.5,
    y2: -202.2,
    gradientTransform: "translate(-3.6 -1.8)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 446.7,
    y1: -139.8,
    x2: 425.4,
    y2: -267.9,
    gradientTransform: "translate(-3.6 -1.8)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "e",
    x1: 20.1,
    y1: -202.2,
    x2: 462,
    y2: -202.2,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5587a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457d8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1,
    y1: -202.2,
    x2: 32.6,
    y2: -123.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1,
    y1: -202.2,
    x2: 32.6,
    y2: -123.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1,
    y1: -202.2,
    x2: 32.6,
    y2: -123.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: -123.5,
    x2: 32.6,
    y1: -202.2,
    x1: 20.1,
    gradientUnits: "userSpaceOnUse",
    id: "i",
    xlinkHref: "#d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10091 0 0 1.1004 -8.8 480)",
    fill: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.3-422.1l26.5 116.7-56.6 91L147-272l-26.6-116.7z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1-229.8l116.7-26.6 91 56.6-57.5 90.2L53.6-83z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 17.7L186.4-99l56.6-91 90.3 57.5 26.6 116.7z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462-175l-116.7 26.6-91-56.6 57.5-90.3 116.7-26.6z",
    fill: "url(#i)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10091 0 0 1.1004 -4.8 482)",
    fill: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252-404.4l20.4 89.3-45.2 70.7-71.2-44.1-20.4-89.4z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36-220.1l89.3-20.4 70.7 45.3-44.1 71.2-89.4 20.3z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221-3.6L200.4-93l45.3-70.6 71.2 44 20.4 89.4z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.9-188.4L349.5-168l-70.6-45.3 44-71.2 89.4-20.3z",
    fill: "url(#n)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.94f885ce93dfb6d29a122402a15cccca.svg";
export { ForwardRef as ReactComponent };